<template>
  <div class="overflow-hidden rounded-lg bg-white shadow">
    <div class="px-4 py-5 sm:p-6">
      <div class="sm:flex sm:items-center">
        <div class="sm:flex-auto">
          <h1 class="text-base font-semibold leading-6 text-gray-900">Question Sets</h1>
          <p class="mt-2 text-sm text-gray-700">A list of all the Question Sets.</p>
        </div>
      </div>
      <div class="mt-8 flow-root">
        <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
            <table class="min-w-full divide-y divide-gray-300">
              <thead>
              <tr>
                <th scope="col" class="py-1 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">ID</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Name</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Key</th>
                <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Status</th>
                <th scope="col" class="px-3 py-1 text-right text-sm font-semibold text-gray-900">Options</th>
              </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
              <tr v-for="item in items" :key="item.id">
                <td class="whitespace-nowrap py-1 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">{{ item.id }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.name }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.key }}</td>
                <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.status }}</td>
                <td class="py-1 pl-3 text-sm font-medium sm:pr-0">
                  <div class="flex items-center justify-end gap-x-0">
                    <button v-if="canPublish" @click="openModal(item.id)" type="button" class="network-button-color hover:text-gray-900">
                      <CloudArrowUpIcon class="m-1 h-6 w-6" aria-hidden="true" />
                    </button>
                    <button @click="clone(item.id)" type="button" class="network-button-color hover:text-gray-900">
                      <DocumentDuplicateIcon class="m-1 h-6 w-6" aria-hidden="true" />
                    </button>
                    <RouterLink :to="{ name: 'QuestionSetShow', params: { id: item.id } }" class="network-button-color hover:text-gray-900">
                      <EyeIcon class="m-1 h-6 w-6" aria-hidden="true" />
                    </RouterLink>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
            <PaginationComponent :response="meta" @setPage="getItems"></PaginationComponent>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "../TwPaginationComponent.vue";
import {PencilSquareIcon, EyeIcon, ListBulletIcon, TrashIcon, DocumentDuplicateIcon, CloudArrowUpIcon} from "@heroicons/vue/20/solid";
import {useModal, useModalSlot} from "vue-final-modal";
import TwModal from "../TwModal.vue";
import QuestionSetPublishDraftFormComponent from "./QuestionSetPublishDraftFormComponent.vue";

export default {
  name: "QuestionSetIndexComponents",
  data() {
    return {
      items: [],
      meta: {},
      page: null,
      thisPage: null
    }
  },
  components: {
    PaginationComponent,
    PencilSquareIcon,
    EyeIcon,
    ListBulletIcon,
    TrashIcon,
    DocumentDuplicateIcon,
    CloudArrowUpIcon,
  },
  computed: {
    canPublish() {
      return this.$store.state.account.features.question_sets_publish_draft_to_live;
    },
  },
  methods: {
    getItems(page = null) {
      this.thisPage = page;
      axios.get(`/member-firm/question-set/index?page=${page}`).then((res) => {
        this.items = res.data.data;
        if (this.items.length === 1) {
          this.$router.push({ name: 'QuestionSetShow', params: { id: this.items[0].id } });
        }
        this.meta = res.data.meta;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    clone(id) {
      if(confirm("Do you really want to clone?")) {
        axios.get(`/member-firm/question-set/clone/${id}`).then((res) => {
          this.$notify({ type: "success", title: "Successfully", text: res.data.message });
          this.getItems();
        }).catch((error) => {
          console.log('error', error)
          this.$notify({ title: "Unsuccessfully", text: error.message });
        })
      }
    },
    openModal(draftQuestionSetId) {
      const self = this;
      const { open, close } = useModal({
        component: TwModal,
        attrs: {
          onClose() {
            close()
          },
        },
        slots: {
          default: useModalSlot({
            component: QuestionSetPublishDraftFormComponent,//
            attrs: {
              draftQuestionSetId: draftQuestionSetId,
              onReloadIndex() {
                self.getItems();
              },
              onCancel() {
                close()
              },
            },
          })
        },
      });
      open();
    },
  },
  created() {
    this.getItems();
  },
}
</script>